var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.$route.name === 'playlists-view' || _vm.$route.name === 'playlists-info-view')?_c('PlaylistsMain'):(_vm.$route.name === 'playlists-create-view' || _vm.$route.name === 'playlists-edit-view')?_c('PlaylistCreateEdit'):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }